import { render, staticRenderFns } from "./ContactInfoColumn.vue?vue&type=template&id=1b377ff6&scoped=true&"
import script from "./ContactInfoColumn.vue?vue&type=script&lang=js&"
export * from "./ContactInfoColumn.vue?vue&type=script&lang=js&"
import style0 from "./ContactInfoColumn.vue?vue&type=style&index=0&id=1b377ff6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b377ff6",
  null
  
)

export default component.exports